module.exports = __webpack_public_path__ + "static/member_03-913eb742f5575cd9de1b1e010e949b6b.jpg";